import { render } from "./BI.vue?vue&type=template&id=1f7d3a96&scoped=true"
import script from "./BI.vue?vue&type=script&lang=js"
export * from "./BI.vue?vue&type=script&lang=js"

import "./BI.vue?vue&type=style&index=0&id=1f7d3a96&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrateur\\Documents\\davca-cm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7d3a96"]])

export default __exports__